import { IDialog } from './IDialog';
import { OnInit, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export class DialogComponentContent implements IDialog{

    constructor(protected element: ElementRef, protected containerSelector: string = ".modal"){

    }

    ngOnInit(){
        $(this.element.nativeElement).find(this.containerSelector).delay(185).fadeIn(100);
    }

    close(dialogReference: MatDialogRef<any>, result = null){
        $(this.element.nativeElement).find(this.containerSelector).fadeOut(50);
        dialogReference.close(result);
    }
}